import React, { useState } from 'react'
import { Form, Input, message, Switch, Table } from 'antd'
import axios from 'axios'

const { Search } = Input
const App = () => {
  const formRef = React.useRef(null)
  const inputRef = React.useRef(null)
  const [result, setResult] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isLoop, setLoop] = useState(true)
  const [showCodeArea, setShowCodeArea] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])
  const onChange = (checked) => {
    console.log(`switch to ${checked}`)
    setLoop(checked)
  }
  const onSearch = (value) => {
    setTimeout(() => {
      // 手动触发表单验证
      formRef.current
        .validateFields()
        .then(() => {
          fetchData(value)
        })
        .catch((errorInfo) => {})
    }, 100);
  }
  const fetchData = async (str) => {
    // 先清空原来的
    setResult('')
    setShowCodeArea(false)
    setIsLoading(true)
    try {
      const result = await axios.post(`audio`, {
        url: str,
      })
      // 显示代码区域
      setShowCodeArea(true)
      const audioArray = result.data
      setResult(audioArray)
    } catch (error) {
      console.log(error)
      if (error.response.status === 500) {
        messageApi.open({
          type: 'error',
          content: '该网址访问不到',
        })
      }
    } finally {
      setIsLoading(false)
    }
  }
  const columns = [
    {
      title: '标题',
      dataIndex: 'name',
    },
    {
      title: '播放',
      dataIndex: 'src',
      render: (value) => (
        <audio
          style={{
            marginTop: '10px',
          }}
          src={value}
          controls
          loop={isLoop}
        ></audio>
      ),
    },
  ]
  return (
    <>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 16,
        }}
        autoComplete="off"
        initialValues={{
          str: 'https://mp.weixin.qq.com/s/Q7jich4VXUCBRK4RWRYuiA',
        }}
      >
        <Form.Item
          label="文章链接"
          name="str"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入文章链接',
            },
            {
              pattern: new RegExp(
                '^(https?:\\/\\/)?' + // protocol
                  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                  '(\\#[-a-z\\d_]*)?$',
                'i'
              ),
              message: '请输入正确的网址',
              validateFirst: true,
            },
          ]}
        >
          <Search
            ref={inputRef}
            onSearch={onSearch}
            enterButton
            loading={isLoading}
            allowClear
          />
        </Form.Item>
        <Form.Item label="单曲循环">
          <Switch defaultChecked={isLoop} onChange={onChange} />
        </Form.Item>
      </Form>
      {showCodeArea ? (
        <Table columns={columns} dataSource={result} rowKey="mediaId" />
      ) : (
        ''
      )}
      {contextHolder}
    </>
  )
}
export default App
